import { getTeam } from "@coworker/app/src/hooks/API/core.service";
import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { Team } from "../types/team";

export function useTeamQuery(teamId: string | undefined) {
  return useQuery<Team>({
    queryKey: ["team", teamId],
    queryFn: async () => await getTeam(teamId!),
    enabled: Boolean(teamId),
    staleTime: 15 * INTERVAL.MINUTE, // ponytail: match sibling useStoreTeamsQuery
    gcTime: 15 * INTERVAL.MINUTE,
    retry: false,
  });
}
